var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #bfeaea;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-2, .cls-3 {\n        stroke: #00a9a9;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 30px;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 600,
    cy: 600.18,
    r: 557.49
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 279.01,
    y: 257.79,
    width: 181.83,
    height: 181.83,
    rx: 90.92,
    ry: 90.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 279.01,
    y: 510.24,
    width: 181.83,
    height: 181.83,
    rx: 90.92,
    ry: 90.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 279.01,
    y: 762.69,
    width: 181.83,
    height: 181.83,
    rx: 90.92,
    ry: 90.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 532.97,
    y1: 348.7,
    x2: 916.39,
    y2: 348.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "337.29 344.58 361.8 369.09 402.57 328.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 532.97,
    y1: 601.15,
    x2: 916.39,
    y2: 601.15
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "337.29 597.04 361.8 621.54 402.57 580.77"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 532.97,
    y1: 853.61,
    x2: 916.39,
    y2: 853.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "337.29 849.49 361.8 873.99 402.57 833.22"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.8775e16416c9ca42f09aa8c9e8a4c61d.svg";
export { ForwardRef as ReactComponent };